import * as React from "react";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import IconButton from "@mui/material/IconButton/IconButton";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import moment from "moment/moment";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
export default function MediaFileMessageComponent({ msg, type }) {
	const imgExtPattern = /.gif|.png|.jpg/;
	const videoExtPattern = /.mp4|.ogg|.webm/;
	const [autoplay, setAutoplay] = React.useState(false);
	if (type === "r") {
		return (
			<Stack direction={"row-reverse"} spacing={1}>
				<Stack
					direction={"column"}
					spacing={0.5}
					sx={{ p: 0, color: "text.secondary", maxWidth: "70%" }}
					justifyContent="flex-end"
					alignItems="flex-end">
					{imgExtPattern.test(msg.file) && msg?.uri && (
						<img
							src={msg?.uri}
							style={{
								height: 180,
								width: 150,
								objectFit: "cover",
							}}
							alt={
								msg?.file.split("/")[
									msg?.file.split("/").length - 1
								]
							}
						/>
					)}
					{videoExtPattern.test(msg.file) && msg?.uri && (
						<video
							onClick={() => setAutoplay(!autoplay)}
							autoPlay={autoplay}
							controls={true}
							src={msg?.uri}
							style={{
								height: 300,
								width: 300,
							}}
							alt={
								msg?.file.split("/")[
									msg?.file.split("/").length - 1
								]
							}
						/>
					)}
					<Stack direction={"row"} spacing={0.5}>
						<Typography
							variant={"caption"}
							noWrap
							sx={{ width: 93 }}>
							{
								msg?.file.split("/")[
									msg?.file.split("/").length - 1
								]
							}
						</Typography>
						<Typography variant={"caption"}>
							{msg.createdAt &&
								moment(msg.createdAt.seconds * 1000).format(
									"HH:mm"
								)}
						</Typography>

						{msg.read === true ? (
							<DoneAllOutlinedIcon
								style={{ color: "#4acfee", fontSize: 18 }}
							/>
						) : (
							<DoneAllOutlinedIcon
								style={{ color: "#ccc", fontSize: 18 }}
							/>
						)}
					</Stack>
				</Stack>
			</Stack>
		);
	} else {
		return (
			<Stack direction={"row"} spacing={1}>
				<Stack
					direction={"column"}
					spacing={0.5}
					sx={{ p: 0, color: "text.secondary", maxWidth: "70%" }}
					justifyContent="flex-end"
					alignItems="flex-end">
					{imgExtPattern.test(msg.file) && msg?.uri && (
						<img
							src={msg?.uri}
							style={{
								height: 180,
								width: 150,
								objectFit: "cover",
							}}
							alt={
								msg?.file.split("/")[
									msg?.file.split("/").length - 1
								]
							}
						/>
					)}
					{videoExtPattern.test(msg.file) && msg?.uri && (
						<video
							onClick={() => setAutoplay(!autoplay)}
							autoPlay={autoplay}
							controls={true}
							src={msg?.uri}
							style={{
								height: 300,
								width: 300,
							}}
							alt={
								msg?.file.split("/")[
									msg?.file.split("/").length - 1
								]
							}
						/>
					)}
					<Stack direction={"row"} spacing={0.5}>
						<Typography variant={"caption"} color={"secondary"}>
							{msg.createdAt &&
								moment(msg.createdAt.seconds * 1000).format(
									"HH:mm"
								)}
						</Typography>
					</Stack>
				</Stack>
			</Stack>
		);
	}
}
